"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var createReducer = function () { return function (state, action) {
    if (action.type === 'start') {
        return {
            isLoading: true,
            result: null,
            error: null,
            wasSuccessful: false,
        };
    }
    if (action.type === 'succeed') {
        return {
            isLoading: false,
            result: action.payload,
            error: null,
            wasSuccessful: true,
        };
    }
    if (action.type === 'fail') {
        return {
            isLoading: false,
            result: null,
            error: action.payload,
            wasSuccessful: false,
        };
    }
    if (action.type === 'reset') {
        return constants_1.initialState;
    }
    return state;
}; };
exports.default = createReducer;
//# sourceMappingURL=reducer.js.map